// extracted by mini-css-extract-plugin
export default {"productCarousel":"o1-z"};